import { getStoryBySlug } from '@cinch-nx/data-storyblok'
import { traceFunction } from '@core/datadog-server'
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'
import { offerPageFallbackStory } from './storyblok/data/fallback-json'
import { NewCarsOffersStory } from './storyblok/storyblok'

async function getStory(preview: boolean) {
  try {
    return await getStoryBySlug<NewCarsOffersStory>('new-cars-offers', {
      version: preview ? 'draft' : 'published',
      resolve_relations:
        'FinanceOffersCarousel.financeRepresentativeExample,FinanceOffersCarouselReference.financeOffersCarousel',
    })
  } catch {
    return offerPageFallbackStory
  }
}

export async function getStaticPropsfn({
  preview = false,
}: GetStaticPropsContext) {
  const story = await getStory(preview)

  return {
    props: {
      story,
      preview,
      layoutProps: {
        heroProps: story.content.hero[0],
        showBorderRadius: true,
      },
    },
    revalidate: 60,
  }
}

export const getStaticProps = traceFunction(
  'newCarsOffers.getStaticProps',
  getStaticPropsfn,
)

export type NewCarsOffersProps = InferGetStaticPropsType<typeof getStaticProps>
